<template>
    <a
        class="kgr-button kgr-button--link"
        @click="redirectToOverview"
    >
        <kgr-icon
            icon-class="arrow-left"
            class="kgr-button__icon kgr-button__icon--left"
        />
        <span>{{ tBackToOverview }}</span>
    </a>
</template>

<script>
import Icon from '../common/icon/Icon.vue';

export default {
    components: {
        'kgr-icon': Icon,
    },
    props: {
        clubId: {
            type: Number,
            required: true,
        },
    },
    computed: {
        tBackToOverview() {
            return this.$t('backToOverview');
        },
    },
    methods: {
        redirectToOverview() {
            window.location = `/backend/clubs/${this.clubId}/offerings/`;
        },
    },
};
</script>

<style scoped lang="scss"></style>
